import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'm-page-banner',
  exportAs: 'mPageBanner',
  template: `
    <ng-container>
      <div
        class="m-page-banner-container"
        *ngIf="mShowPageBanner"
        [ngStyle]="{ 'background-image': 'url(' + mBgUrl + ')', 'background-color': mBgColor }"
      >
        <div class="title">{{ mTitle }}</div>
        <div class="desc" [style.width.px]="mDescWidth">{{ mDesc }}</div>
        <i nz-icon class="icon" *ngIf="mShowCloseIcon" nzType="close-circle" nzTheme="fill" (click)="close()"></i>
      </div>
    </ng-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class MPageBannerComponent {
  @Input() mTitle = ''; // 标题
  @Input() mDesc = ''; // 描述
  @Input() mBgUrl = ''; // 背景url
  @Input() mDescWidth = 660; // 描述块区的宽度
  @Input() mBgColor = '#107CEE'; // 背景颜色
  @Input() mShowCloseIcon = false; // 是否支持可关闭，默认不支持
  @Input() mShowPageBanner = true; // banner当前关闭与否的状态，默认展示

  @Output() readonly mShowPageBannerChange = new EventEmitter<boolean>();

  close(): void {
    this.mShowPageBanner = !this.mShowPageBanner;
    this.mShowPageBannerChange.emit(this.mShowPageBanner);
  }
}
